<template>
    <div class="job-page__profiles__tabs">
        <ul>
            <template v-for="{name, label} in tabs" :key="name">
                <li>
                    <span :class="{active: name === current}" @click="current = name">
                        {{ label }}
                    </span>
                </li>
            </template>
        </ul>
    </div>
</template>

<script setup lang="ts">
    const current = defineModel<string>();
    defineProps<{tabs: {label: string; name: string}[]}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__profiles__tabs {
        margin: 0 auto;
        user-select: none;
        text-align: center;
        margin-bottom: var(--joy-core-spacing-10);

        @include mq.screen_sm(min) {
            margin-bottom: var(--joy-core-spacing-12);
        }

        ul {
            list-style-type: none;
            margin: 0 auto;
            @include mq.screen_sm(min) {
                display: inline-flex;
            }
        }
        li {
            span {
                display: inline-block;
                padding: var(--joy-core-spacing-2) var(--joy-core-spacing-12);
                cursor: pointer;
                border-bottom: 2px solid var(--joy-color-neutral-30);
                border-left-width: 0;
                width: 100%;
                min-width: 225px;
                max-width: 350px;

                &.active {
                    font-weight: var(--joy-font-weight-bold);
                    color: var(--joy-color-primary-50);
                    border-color: var(--joy-color-primary-50);
                }

                @include mq.screen_sm(min) {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: var(--joy-core-spacing-11);
                    border: 2px solid var(--joy-color-primary-50);
                    border-left-width: 0;
                    max-width: none;

                    &:hover {
                        background-color: var(--joy-color-primary-10);
                    }
                    &.active {
                        background-color: var(--joy-color-primary-50);
                        font-weight: var(--joy-font-weight-normal);
                        color: var(--joy-color-neutral-0);
                        cursor: default;
                    }
                }
            }
            @include mq.screen_sm(min) {
                &:first-child span {
                    border-left-width: 2px;
                    border-top-left-radius: var(--joy-core-spacing-12);
                    border-bottom-left-radius: var(--joy-core-spacing-12);
                }
                &:last-child span {
                    border-top-right-radius: var(--joy-core-spacing-12);
                    border-bottom-right-radius: var(--joy-core-spacing-12);
                }
            }
        }
    }
</style>
